import React from 'react'
import PropTypes from 'prop-types'

const NavTabHeaderMobile = ({ focusOutOnClick }) => {
  return (
    <nav arial-label='Segmento' className='menu menu-segmentation'>
      <div className='container'>
        <div className='flexible-items-container' role='menubar' aria-label='selecionar o seguimento'>
          <a href='/' aria-label='para você, página atual' className='flex-item mn-item mn-personal current-home-page' role='menuitem' onClick={() => focusOutOnClick()}>para você</a>
          <a href='/meu-negocio' className='flex-item mn-item mn-business' role='menuitem' onClick={() => focusOutOnClick()}>para o seu negócio</a>
        </div>
      </div>
    </nav>
  )
}

NavTabHeaderMobile.propTypes = {
  focusOutOnClick: PropTypes.func
}

export default NavTabHeaderMobile



// WEBPACK FOOTER //
// ./src/App/Header/NavTabHeaderMobile.js